import { Box, Button, Card, CardContent, Grid, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import useResponsive from '../../../hooks/useResponsive';

export default function BCMASadvertisement() {
  const isDesktop = useResponsive('up', 'md');
  return (
    <Box>
      <Card sx={{ background: 'linear-gradient(135deg,  #0c3a57, #014459)', color: 'white' }}>
        <CardContent>
          <Grid container spacing={2} sx={{ p: 3 }}>
            <Grid item md={6} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <img
                className="bouncing-image"
                src="https://acma-media-bucket.s3.us-east-2.amazonaws.com/images/brand/biologics-ai/bcbbs-badge.svg"
                alt="bcmas-seal"
                width="50%"
              />
            </Grid>
            <Grid item md={6} sx={{ flexDirection: 'column', display: 'flex', justifyContent: 'center' }}>
              <Typography variant="h3">Become a Certified Biologics and Biosimilars Specialist (BCBBS™)</Typography>

              <Typography variant="h6" sx={{ fontWeight: 500 }}>
                BCBBS is the first and only accredited Board Certification for the Biologics and Biosimilars specialty
                area
              </Typography>
              <Box sx={{ mt: 2 }}>
                <Button
                  sx={{
                    backgroundColor: 'white',
                    fontSize: '18px',
                    color: 'black',
                    '&:hover': { backgroundColor: '#dfdfdf' },
                    mr: 2,
                  }}
                  target="_blank"
                  fullWidth={!isDesktop}
                  size="large"
                  href="https://medicalaffairsspecialist.org/certifications/bcbbs"
                >
                  Learn more
                </Button>

                <Button
                  fullWidth={!isDesktop}
                  sx={{
                    backgroundColor: 'white',
                    fontSize: '18px',
                    color: 'black',
                    '&:hover': { backgroundColor: '#dfdfdf' },
                    mt: isDesktop ? 0 : 2,
                  }}
                  target="_blank"
                  href="https://www.acmamarketplace.org/certification/bcbbs"
                >
                  Enroll Today
                </Button>
              </Box>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </Box>
  );
}
